import { useEffect, useState } from "react";

/** From this width (iPad landscape, laptop) the views use two panes and tables. */
export const WIDE = "(min-width: 900px)";

export function useWide(): boolean {
  const query = typeof window !== "undefined" && "matchMedia" in window ? window.matchMedia(WIDE) : null;
  const [wide, setWide] = useState(() => query?.matches ?? false);
  useEffect(() => {
    if (!query) return;
    const on = () => setWide(query.matches);
    query.addEventListener("change", on);
    return () => query.removeEventListener("change", on);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return wide;
}
